'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactScroll = require('react-scroll');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get2 = require('lodash/get');var _get3 = _interopRequireDefault(_get2);
var _lodash = require('lodash');var _lodash2 = _interopRequireDefault(_lodash);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _reactModal = require('react-modal');var _reactModal2 = _interopRequireDefault(_reactModal);
var _reactRouter = require('react-router');

var _PropertyGallery = require('../../../components/PropertyDetailedInfo/PropertyDetails/PropertyGallery');var _PropertyGallery2 = _interopRequireDefault(_PropertyGallery);
var _Lightbox = require('../../../components/PropertyDetailedInfo/Lightbox/Lightbox');var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _containers = require('../../../containers');
var _components = require('../../../components');







var _checkIsForeignAddress = require('../../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _MessageFromCompany = require('../MessageFromCompany/MessageFromCompany');var _MessageFromCompany2 = _interopRequireDefault(_MessageFromCompany);
var _BasicInformation = require('../BasicInformation/BasicInformation');var _BasicInformation2 = _interopRequireDefault(_BasicInformation);
var _ProjectInlineGallery = require('../ProjectInlineGallery/ProjectInlineGallery');var _ProjectInlineGallery2 = _interopRequireDefault(_ProjectInlineGallery);
var _SliderCart = require('../SliderCart/SliderCart');var _SliderCart2 = _interopRequireDefault(_SliderCart);

var _PropertyDetailedForm = require('../../../containers/PropertyDetailedContactsUsForm/PropertyDetailedForm');var _PropertyDetailedForm2 = _interopRequireDefault(_PropertyDetailedForm);


var _modifyImageLink = require('../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants = require('../../../constants');








var _getLocalizedData10 = require('../../../utils/getLocalizedData');var _getLocalizedData11 = _interopRequireDefault(_getLocalizedData10);
var _makeSharingUrl = require('../../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);

var _ProjectDetails = require('./ProjectDetails.scss');var styles = _interopRequireWildcard(_ProjectDetails);
var _images_placeholder = require('../../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var ProjectDetails = function (_Component) {_inherits(ProjectDetails, _Component);function ProjectDetails() {var _temp, _this, _ret;_classCallCheck(this, ProjectDetails);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { headerElement: _this.props.isMobile ? { offsetHeight: 50 } : null,
      galleryElement: null,
      contactsWrapper: null,
      scrollElement: null,
      appWrapper: null,
      printPageShown: false }, _this.





















    componentDidMount = function () {var
      projectId = _this.props.projectData.id;
      var headerElement = document.querySelector('header');
      var galleryElement = document.querySelector('.' + styles.galleryStyle);
      var contactsWrapper = document.querySelector('#stickySection');
      var scrollElement = document.querySelector('.ReactModal__Content');
      var appWrapper = document.scrollingElement || document.documentElement;

      _this.setState({
        headerElement: headerElement,
        galleryElement: galleryElement,
        contactsWrapper: contactsWrapper,
        scrollElement: scrollElement,
        appWrapper: appWrapper });


      if (projectId) {
        if (scrollElement) {
          scrollElement.addEventListener('scroll', _this.handleScroll);
        } else {
          window.addEventListener('scroll', _this.handleScroll);
        }
      }
    }, _this.

























    componentWillUnmount = function () {
      if (_this.state.scrollElement) {
        _this.state.scrollElement.removeEventListener('scroll', _this.handleScroll);
      } else {
        window.removeEventListener('scroll', _this.handleScroll);
      }

      _this.props.changeLightboxActiveSlide(0);
      _this.props.resetDescriptionTranslate();
    }, _this.

    handleScroll = function (evt) {return _this.props.isMobile ? function () {} : _this.desktopHandleScroll(evt);}, _this.

    desktopHandleScroll = function () {var

      isModal =
      _this.props.isModal;var _this$state =






      _this.state,contactsWrapper = _this$state.contactsWrapper,headerElement = _this$state.headerElement,scrollElement = _this$state.scrollElement,galleryElement = _this$state.galleryElement,appWrapper = _this$state.appWrapper;

      var headerOffset = headerElement ? headerElement.offsetHeight : 0;
      var galleryOffset = galleryElement ? galleryElement.offsetHeight : 0;
      var contactsOffsetTop = headerOffset + galleryOffset;
      var offsetTop = scrollElement ? scrollElement.scrollTop : appWrapper.scrollTop;

      if (offsetTop >= contactsOffsetTop - (isModal ? 60 : 80)) {
        if (!contactsWrapper.classList[styles.contactsFixed]) {
          contactsWrapper.style.width = contactsWrapper.offsetWidth + 'px';
          contactsWrapper.classList.add(styles.contactsFixed);
          contactsWrapper.style.top = isModal ? '60px' : '165px';
        }
      } else {
        contactsWrapper.style.width = '';
        contactsWrapper.style.top = '';
        contactsWrapper.classList.remove(styles.contactsFixed);
      }
    }, _this.

    scrollToForm = function () {
      var desktopOffset = _this.props.isModal ? 624 : -297;
      var offset = _this.props.isMobile ? -100 : desktopOffset;

      if (_this.props.isModal) {
        _reactScroll.scroller.scrollTo(_constants.TAB_PROJECT_ID.contactsForm, {
          duration: 500,
          offset: offset,
          containerSelector: '.ReactModal__Content',
          smooth: true });

      } else {
        _reactScroll.scroller.scrollTo(_constants.TAB_PROJECT_ID.contactsForm, {
          duration: 500,
          offset: offset,
          smooth: true });

      }
    }, _this.

    createHelmet = function (id, images, sharingTitle, sharingUrl, description) {
      if (!id) {return null;}

      var meta = [
      { name: 'description', content: description },
      { property: 'og:title', content: sharingTitle },
      { property: 'og:url', content: sharingUrl },
      { property: 'og:description', content: description },
      { name: 'viewport', content: 'width=device-width,user-scalable=no' }];


      var image = images.length > 0 ? images[0] : _constants.onMapLogoSocials;

      if (images.length > 0) {
        meta = [].concat(
        meta, [
        { property: 'og:image', content: image },
        { name: 'image', itemProp: 'image', content: image }]);

      }

      return _react2.default.createElement(_reactHelmet2.default, { title: sharingTitle, meta: meta });
    }, _this.

    generateSEOTitle = function (_ref)








    {var name = _ref.name,status = _ref.status,address = _ref.address,room_range = _ref.room_range,property_types = _ref.property_types,completion_date = _ref.completion_date,min_property_price = _ref.min_property_price,exact_property_price = _ref.exact_property_price;
      var projectName = name[_this.props.locale] || name.he;
      var statusString = _this.props.translate('propertyDetails', status);
      var localisedPropertyTypes = property_types.map(function (type) {return _this.props.translate('propertyTypes', type);});
      var propertyTypes = localisedPropertyTypes.join(', ');

      var rooms = room_range && room_range.join(', ');
      var price = exact_property_price || min_property_price;
      var completionYear = new Date(completion_date).getFullYear() || 0;var _getLocalizedData =






      (0, _getLocalizedData11.default)(address, _this.props.locale, true),_getLocalizedData$res = _getLocalizedData.result,street_name = _getLocalizedData$res.street_name,house_number = _getLocalizedData$res.house_number,city_name = _getLocalizedData$res.city_name,neighborhood = _getLocalizedData$res.neighborhood,country_name = _getLocalizedData$res.country_name;
      var isForeign = country_name !== 'Israel';
      var translate = _this.props.translate('ProjectDetails', 'SEOtitle');

      return (
        _react2.default.createElement('div', null,
          _react2.default.createElement('p', null, translate('projectName'), ' ', projectName, ' ', translate('price'), ' ', price, ' '),
          _react2.default.createElement('p', null, translate('address'),
            street_name, ' ', house_number, ' ', neighborhood !== city_name ? neighborhood : '',
            city_name, isForeign && ', ' + country_name),

          _react2.default.createElement('p', null, translate('propertyTypes'), ' ', propertyTypes, ' ', translate('rooms'), ' ', rooms, ' '),
          _react2.default.createElement('p', null, translate('completionYear'), ' ', completionYear, ' ', translate('status'), ' ', statusString, '.')));


    }, _this.

    formatDate = function (dateString, translate) {
      if (!dateString) {
        return null;
      }

      var fullDay = 86400000; // 24 hours
      var date = (0, _moment2.default)(dateString);
      var today = (0, _moment2.default)().startOf('day');
      var yesterday = (0, _moment2.default)(today - fullDay);

      if (date.isSame(today, 'd')) {
        return translate('propertyDetails', 'today');
      } else if (date.isSame(yesterday, 'd')) {
        return translate('propertyDetails', 'yesterday');
      }

      return date.format('DD/MM/YYYY');
    }, _this.

    formatImages = function () {var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];return images.map(function (link) {return {
          full: link,
          gallery: link,
          thumbnail: link };});}, _this.


    showPrintPage = function () {return _this.setState({ printPageShown: true });}, _this.

    hidePrintPage = function () {
      _this.setState({ printPageShown: !_this.state.printPageShown });
    }, _this.

    renderMessageFromCompany = function () {return (
        _react2.default.createElement(_MessageFromCompany2.default, null));}, _this.


    renderAdvantagesCompany = function () {var _this$props =
      _this.props,locale = _this$props.locale,_this$props$projectDa = _this$props.projectData,advantages = _this$props$projectDa.advantages,address = _this$props$projectDa.address;
      var isForeign = address.en.country_name !== 'Israel';
      var defaultLunguage = isForeign ? _constants.language.fallback : _constants.language.default;

      return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.TAB_PROJECT_ID.advantagesProject, className: styles.advantagesCompanyWrapper },
          _react2.default.createElement('p', { className: styles.title }, _this.props.translate('propertyDetails', 'advantagesOfProject')),
          _react2.default.createElement('div', { className: styles.advantagesCompany },
            advantages.map(function (_ref2) {var title = _ref2.title,description = _ref2.description;return (
                _react2.default.createElement('div', { key: title[locale] || title[defaultLunguage] },
                  _react2.default.createElement('p', { className: styles.title }, title[locale] || title[defaultLunguage]),
                  _react2.default.createElement('p', { className: styles.description }, description[locale] || description[defaultLunguage])));}))));





    }, _this.

    renderLightbox = function () {var _this$props$projectDa2 =
      _this.props.projectData,id = _this$props$projectDa2.id,address = _this$props$projectDa2.address;var _this$props2 =
      _this.props,propertyType = _this$props2.propertyType,isModal = _this$props2.isModal,isNative = _this$props2.isNative;
      var isForeign = address.en.country_name !== 'Israel';
      var images = _this.formatImages(_this.props.projectData.images);var _get =





      (0, _get3.default)(_this.props, 'projectData'),currency = _get.currency,additional_info = _get.additional_info,price = _get.price;

      return (
        _react2.default.createElement(_Lightbox2.default, {
          isModal: isModal,
          isForeign: isForeign,
          isNative: isNative,
          id: id,
          propertyType: propertyType,
          propertyData: {
            currency: currency,
            additional_info: additional_info,
            price: price },

          isProject: true,
          toggleFavorite: _this.props.toggleFavorite,
          isFavorite: _this.props.isFavorite,
          currentImage: _this.props.currentImage || 0,
          changeLightboxActiveSlide: _this.props.isMobile ? _this.props.changeLightboxActiveSlide : null,
          images: images,
          isOpen: _this.props.isLightboxOpen,
          hideLightbox: _this.props.hideLightbox,
          translate: _this.props.translate('propertyDetails'),
          rootTranslate: _this.props.translate,
          locale: _this.props.locale,
          isMobile: _this.props.isMobile,
          isRtl: _this.props.isRtl,
          routeData: _this.props.routeData }));


    }, _this.
































    renderTeammate = function (_ref3, role, idx) {var title = _ref3.title,logo = _ref3.logo;return (
        _react2.default.createElement('div', { className: styles.teammate, key: '' + title + idx },
          !!logo && _react2.default.createElement('img', { src: logo, alt: '' }),
          _react2.default.createElement('p', null, title),
          _react2.default.createElement('p', null, _this.props.translate('addNewProject', role))));}, _this.



    renderTeamBlock = function () {
      var teamOrder = ['owner', 'contractor', 'architect'];
      var teamData = (0, _get3.default)(_this.props, 'projectData.team') || {};

      var architect = (0, _get3.default)(teamData, 'architect.title');
      var contractor = (0, _get3.default)(teamData, 'contractor.title');
      var owner = (0, _get3.default)(teamData, 'owner.title');

      if (!architect && !contractor && !owner) {return null;}

      var team = teamOrder.map(function (role, idx) {return (
          (0, _get3.default)(teamData, '[' + role + '].title') && _this.renderTeammate(teamData[role], role, idx));});


      return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.TAB_PROJECT_ID.developers, className: styles.teamBlock },
          _react2.default.createElement('p', { className: styles.title },
            _this.props.translate('propertyDetails', 'developers')),

          _react2.default.createElement('div', { className: styles.teammateWrapper },
            team)));



    }, _this.

    renderShowAllButton = function () {return (
        _react2.default.createElement('p', { className: styles.showAllButton },
          _react2.default.createElement('i', { className: 'icon icon-arrow-down' }),
          _react2.default.createElement('span', null, _this.props.translate('showAll'))));}, _this.



    renderHideShowAllButton = function () {return (
        _react2.default.createElement('p', { className: styles.hideAll },
          _react2.default.createElement('i', { className: 'icon icon-arrow-down' }),
          _react2.default.createElement('span', null, _this.props.translate('propertyDetails', 'hideDescription'))));}, _this.



    renderStatus = function () {var _this$props3 =
      _this.props,status = _this$props3.projectData.status,translate = _this$props3.translate;

      return (
        _react2.default.createElement('div', { className: styles.status },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.statusLine, styles[status]) },
            _react2.default.createElement('div', { className: styles.iconWrapper },
              _react2.default.createElement('div', { className: styles.planning },
                _react2.default.createElement('i', { className: 'icon icon-check' }),
                _react2.default.createElement('p', { className: status === _constants.STATUS_PROJECT.planning ? styles.active : '' },
                  translate('propertyDetails', 'planning')))),



            _react2.default.createElement('div', { className: styles.iconWrapper },
              _react2.default.createElement('div', { className: styles.construction },
                status === _constants.STATUS_PROJECT.handover && _react2.default.createElement('i', { className: 'icon icon-check' }),
                _react2.default.createElement('p', { className: status === _constants.STATUS_PROJECT.construction ? styles.active : '' },
                  translate('propertyDetails', 'construction')))),



            _react2.default.createElement('div', { className: styles.iconWrapper },
              _react2.default.createElement('div', { className: styles.ready },
                status === _constants.STATUS_PROJECT.handover && _react2.default.createElement('i', { className: 'icon icon-check' }),
                _react2.default.createElement('p', { className: status === _constants.STATUS_PROJECT.handover ? styles.active : '' },
                  translate('propertyDetails', 'ready'))))),




          _react2.default.createElement('div', { className: styles.statusNamesWrapper },
            _react2.default.createElement('p', { className: status === 'planning' ? styles.active : '' },
              translate('propertyDetails', 'planning')),

            _react2.default.createElement('p', { className: status === 'construction' ? styles.active : '' },
              translate('propertyDetails', 'construction')),

            _react2.default.createElement('p', { className: status === 'handover' ? styles.active : '' },
              translate('propertyDetails', 'ready')))));




    }, _this.

    renderSummary = function () {var _this$props4 =
      _this.props,locale = _this$props4.locale,projectData = _this$props4.projectData,translate = _this$props4.translate,summaryData = _this$props4.summaryData;
      var isForeign = (0, _checkIsForeignAddress2.default)(projectData.address);var _getLocalizedData2 =
      (0, _getLocalizedData11.default)(projectData.summary, locale, isForeign),summary = _getLocalizedData2.result;

      var summaryText = !summaryData.showOriginalSummary ?
      summary :
      summaryData.translatedSummaryText;

      return (
        _react2.default.createElement(_reactScroll.Element, {
            name: _constants.TAB_PROJECT_ID.summary,
            className: styles.descriptionBlock },

          _react2.default.createElement('span', { className: styles.title }, translate('ProjectDetails', 'summary')),
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.descriptionWrapper, styles.detailsText) },
            _react2.default.createElement('div', null,
              summaryText,
              summaryData.translatedSummaryRequired && !summary[locale] &&
              _react2.default.createElement('div', { className: styles.translateDescriptionRow },
                _react2.default.createElement('button', {
                    className: styles.showOriginalDescription,
                    onClick: _this.props.toggleSummaryTranslation },

                  _react2.default.createElement('span', null,
                    _this.props.translate('propertyDetails', 'multilingualDescription', summaryData.showOriginalSummary ?
                    'showOriginalDescription' :
                    'returnTranslation')), '\xA0',



                  _react2.default.createElement('span', { className: styles.sub }, 'Powered by Google')), '\xA0\xA0')))));








    }, _this.

    renderDescription = function () {var _this$props5 =




      _this.props,locale = _this$props5.locale,projectData = _this$props5.projectData,descriptionData = _this$props5.descriptionData;
      var isForeign = (0, _checkIsForeignAddress2.default)(projectData.address);
      var translate = _this.props.translate('propertyDetails');var _getLocalizedData3 =

      (0, _getLocalizedData11.default)(projectData.description, locale, isForeign),description = _getLocalizedData3.result;

      var localisedPropertyTypes = projectData.property_types.map(function (type) {return _this.props.translate('propertyTypes', type);});
      var propertyTypesString = localisedPropertyTypes.join(', ');

      var descriptionText = !descriptionData.showOriginalDescription ?
      description :
      descriptionData.translatedDescriptionText;

      return (
        _react2.default.createElement(_reactScroll.Element, {
            name: _constants.TAB_PROJECT_ID.description,
            className: styles.descriptionBlock },

          _react2.default.createElement('span', { className: styles.title }, translate('description')),
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.descriptionWrapper, styles.detailsText) },
            _react2.default.createElement('div', null,
              _react2.default.createElement(_components.ShowMore, {
                text: descriptionText,
                withoutEllipses: true,
                showHideButton: true,
                moreButtonText: _this.renderShowAllButton(),
                hideButtonText: _this.renderHideShowAllButton(),
                customStyles: styles.showMoreWrap,
                heightLimit: 100 }),

              descriptionData.translatedDescriptionRequired && !description[_this.props.locale] &&
              _react2.default.createElement('div', { className: styles.translateDescriptionRow },
                _react2.default.createElement('button', {
                    className: styles.showOriginalDescription,
                    onClick: _this.props.toggleDescriptionTranslation },

                  _react2.default.createElement('span', null,
                    translate('multilingualDescription', descriptionData.showOriginalDescription ?
                    'showOriginalDescription' :
                    'returnTranslation')), '\xA0',



                  _react2.default.createElement('span', { className: styles.sub }, 'Powered by Google')), '\xA0\xA0')),





            _react2.default.createElement('div', { className: styles.informationWrapper },
              _react2.default.createElement('div', { className: styles.statusWrapper },
                _react2.default.createElement('p', { className: styles.title }, _this.props.translate('ProjectDetails', 'status')),
                _this.renderStatus()),

              projectData.completion_date &&
              _react2.default.createElement('div', null,
                _react2.default.createElement('p', { className: styles.title }, _this.props.translate('ProjectDetails', 'expectedOccupancy'), ':\xA0'),
                _react2.default.createElement('p', { className: styles.text }, (0, _moment2.default)(projectData.completion_date).locale(locale || 'he').format('MMMM YYYY'))),


              propertyTypesString &&
              _react2.default.createElement('div', null,
                _react2.default.createElement('p', { className: styles.title }, _this.props.translate('ProjectDetails', 'propertyTypes'), ':\xA0'),
                _react2.default.createElement('p', { className: styles.text }, propertyTypesString)),


              projectData.room_range.join(', ') &&
              _react2.default.createElement('div', null,
                _react2.default.createElement('p', { className: styles.title }, _this.props.translate('ProjectDetails', 'rooms'), ':\xA0'),
                _react2.default.createElement('p', { className: styles.text }, projectData.room_range.join(', ')))))));







    }, _this.

    renderAboutCompany = function () {var _this$props6 =
      _this.props,locale = _this$props6.locale,_this$props6$projectD = _this$props6.projectData,projectsCount = _this$props6$projectD.projectsCount,description = _this$props6$projectD.agency_by_owner.description;

      return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.TAB_PROJECT_ID.aboutCompany, className: styles.aboutCompanyWrapper },
          _react2.default.createElement('p', { className: styles.title },
            _this.props.translate('propertyDetails', 'aboutCompany')),

          _react2.default.createElement('div', { className: styles.aboutCompany },
            _react2.default.createElement('p', { className: styles.text },
              description[locale] || description.he),

            _react2.default.createElement('div', { className: styles.projectsNumberWrapper },
              _react2.default.createElement('p', { className: styles.titleNumber },
                _this.props.translate('propertyDetails', 'projectsNumber')),

              _react2.default.createElement('p', { className: styles.number }, projectsCount)))));




    }, _this.

    renderHeader = function () {var _this$props7 =


















      _this.props,isMobile = _this$props7.isMobile,locale = _this$props7.locale,routeData = _this$props7.routeData,preloadData = _this$props7.preloadData,propertyNote = _this$props7.propertyNote,isModal = _this$props7.isModal,handlePopupClose = _this$props7.handlePopupClose,toggleFavorite = _this$props7.toggleFavorite,isFavorite = _this$props7.isFavorite,projectData = _this$props7.projectData,userData = _this$props7.userData,handleEdit = _this$props7.handleEdit,isNative = _this$props7.isNative,_this$props7$projectD = _this$props7.projectData,address = _this$props7$projectD.address,id = _this$props7$projectD.id;var _getLocalizedData4 =

      (0, _getLocalizedData11.default)(address, locale),localisedAddress = _getLocalizedData4.result;

      var isForeign = address.en.country_name !== 'Israel';
      var translate = _this.props.translate('propertyDetails');

      if (isMobile) {
        return (
          _react2.default.createElement(_components.PropertyToolsBarMobile, {
            toggleFavorite: toggleFavorite,
            locale: locale,
            translate: translate,
            rootTranslate: _this.props.translate,
            isMobile: isMobile,
            isNative: isNative,
            isForeign: isForeign,
            fetchPropertyNote: propertyNote,
            addPropertyNote: _this.props.addPropertyNote,
            hidePrintPage: _this.hidePrintPage,
            printPageShown: _this.state.printPageShown,
            id: id,
            routeData: routeData,
            preloadData: preloadData,
            isFavorite: isFavorite,
            userData: userData,
            handleEdit: handleEdit,
            propertyData: projectData }));


      }

      return (
        _react2.default.createElement(_components.PropertyToolsBar, {
          isProject: true,
          toggleFavorite: toggleFavorite,
          isFavorite: isFavorite,
          localisedAddress: localisedAddress,
          locale: locale,
          translate: translate,
          rootTranslate: _this.props.translate,
          isMobile: isMobile,
          isForeign: isForeign,
          fetchPropertyNote: propertyNote,
          addPropertyNote: _this.props.addPropertyNote,
          hidePrintPage: _this.hidePrintPage,
          printPageShown: _this.state.printPageShown,
          id: id,
          routeData: routeData,
          handlePopupClose: handlePopupClose,
          preloadData: preloadData,
          isModal: isModal,
          userData: userData,
          handleEdit: handleEdit,
          propertyData: projectData }));


    }, _this.

    renderProjectCommoditiesBlock = function () {
      var commodities = (0, _get3.default)(_this.props, 'projectData.commodities');

      return (
        _react2.default.createElement(_reactScroll.Element, { name: _constants.TAB_PROJECT_ID.extras, className: styles.commoditiesBlock },
          _react2.default.createElement('span', { className: styles.title }, _this.props.translate('addNewProject', 'commodities')),
          _react2.default.createElement('div', { className: styles.commodities },
            commodities.map(function (_ref4) {var _ref4$type = _ref4.type,type = _ref4$type === undefined ? '' : _ref4$type,_ref4$items = _ref4.items,items = _ref4$items === undefined ? [] : _ref4$items;return (
                _react2.default.createElement('div', { key: type },
                  _react2.default.createElement('p', { className: styles.commoditieTitle }, _this.props.translate('addNewProject', type)),
                  items.map(function (item, idx) {
                    var key = item + '-' + idx;
                    return (
                      _react2.default.createElement('p', { key: key },
                        _react2.default.createElement('i', { className: 'icon icon-check' }),
                        item));


                  })));}))));





    }, _this.

    renderProjectsCell = function (project) {var _this$props8 =
      _this.props,locale = _this$props8.locale,isMobile = _this$props8.isMobile,isRtl = _this$props8.isRtl;
      var name = (0, _getLocalizedData11.default)(project.name, locale);
      var summary = (0, _getLocalizedData11.default)(project.summary, locale);
      var address = (0, _getLocalizedData11.default)(project.address, locale, true);

      var image = (0, _get3.default)(project, 'images[0]') || null;
      var logo = (0, _get3.default)(project, 'logo', null);
      var statusLocaliseData = _constants.projectStatuses.find(function (item) {return item.name === project.status;}) || {};
      var status = (0, _getLocalizedData11.default)(statusLocaliseData.localisation, locale);
      var route = (0, _appendLocale2.default)(
      locale, '/project_details/' +
      project.id);

      var openDetailsPopup = function openDetailsPopup() {return window.open(route);};

      return (
        _react2.default.createElement('div', { key: project.id },
          _react2.default.createElement(_components.ProjectCellWrapper, {
            className: styles.projectCell,
            locale: locale,
            isMobile: isMobile,
            isRtl: isRtl,
            id: project.id,
            openDetailsPopup: openDetailsPopup,
            rooms: project.rooms || '',
            childProps: {
              images: project.images,
              image: image && typeof image === 'string' ? (0, _modifyImageLink2.default)(image, _constants.imageModifierTypes.PROJECT_THUMBNAIL) : null,
              price: project.min_property_price,
              exactPrice: project.exact_property_price,
              name: name.result,
              logo: logo,
              locale: locale,
              isMobile: isMobile,
              summary: summary.result,
              address: address.result || {},
              status: status.result,
              translate: _this.props.translate,
              location: _this.props.routeData.location } })));




    }, _this.

    renderTab = function (item) {return (
        _react2.default.createElement(_reactScroll.Link, {
            className: styles.tab,
            'data-element': item.key,
            key: item.key,
            spy: true,
            activeClass: styles.activeTab,
            duration: 500,
            to: item.key,
            smooth: true,
            offset: -100 },

          _react2.default.createElement('span', null, _this.props.translate('ProjectDetails', 'tabList', item.key))));}, _this.



    renderTabs = function () {
      var commodities = (0, _get3.default)(_this.props, 'projectData.commodities');
      var advantages = (0, _get3.default)(_this.props, 'projectData.advantages');
      var agencyByOwner = (0, _get3.default)(_this.props, 'projectData.agency_by_owner');
      var teamData = (0, _get3.default)(_this.props, 'projectData.team', {});
      var projectProperties = (0, _get3.default)(_this.props, 'projectProperties');
      var architect = (0, _get3.default)(teamData, 'architect.title');
      var contractor = (0, _get3.default)(teamData, 'contractor.title');
      var owner = (0, _get3.default)(teamData, 'owner.title');
      var messages = (0, _get3.default)(_this.props, 'projectData.messages');
      var isOwner = (0, _get3.default)(_this.props, 'projectData.owner_id') === (0, _get3.default)(_this.props, 'userId');

      var tabs = [
      {
        showTab: true,
        key: _constants.TAB_PROJECT_ID.main },

      {
        showTab: !(0, _isEmpty2.default)(messages) || isOwner,
        key: _constants.TAB_PROJECT_ID.messageCompany },

      {
        showTab: !!advantages && !!advantages.length,
        key: _constants.TAB_PROJECT_ID.advantagesProject },

      {
        showTab: true,
        key: _constants.TAB_PROJECT_ID.summary },

      {
        showTab: true,
        key: _constants.TAB_PROJECT_ID.description },

      {
        showTab: !!agencyByOwner,
        key: _constants.TAB_PROJECT_ID.aboutCompany },

      {
        showTab: !!architect || !!contractor || !!owner,
        key: _constants.TAB_PROJECT_ID.developers },

      {
        showTab: commodities && commodities.length,
        key: _constants.TAB_PROJECT_ID.extras },

      {
        showTab: !!projectProperties && !!projectProperties.length,
        key: _constants.TAB_PROJECT_ID.typesProperties },

      {
        showTab: true,
        key: _constants.TAB_PROJECT_ID.contactsForm }].

      filter(function (value) {return value.showTab;});

      return (
        _react2.default.createElement('div', { className: styles.tabs },
          tabs.map(_this.renderTab)));


    }, _this.
























    renderProjectsBlock = function () {var _this$props9 =
      _this.props,isMobile = _this$props9.isMobile,projectData = _this$props9.projectData;
      var projects = _lodash2.default.filter((0, _get3.default)(projectData, 'projects_by_owner', []), function (project) {return project.id !== projectData.id;});

      if (!projects.length) {return null;}

      return (
        _react2.default.createElement('div', { className: styles.projectsWrapper },
          _react2.default.createElement(_SliderCart2.default, {
              isShowNavigation: projects.length >= 3 || isMobile,
              title: _this.props.translate('propertyDetails', 'projects') },

            projects.map(_this.renderProjectsCell))));



    }, _this.

    renderContactsForm = function () {return (
        _react2.default.createElement('div', { className: styles.contactsFormBlockWrapper },
          _react2.default.createElement(_reactScroll.Element, { name: _constants.TAB_PROJECT_ID.contactsForm },
            _react2.default.createElement(_PropertyDetailedForm2.default, {
              isModal: _this.props.isModal,
              entityId: _this.props.projectData.id,
              entityType: 'project' }))));}, _this.





    renderSimilarProjects = function () {return (
        _react2.default.createElement('div', { className: styles.similarProjectsWrapper },
          _react2.default.createElement(_SliderCart2.default, {
              title: _this.props.translate('propertyDetails', 'similarProjects') },

            _this.props.properties.map(_this.renderProjectsCell))));}, _this.




    renderPropertiesBlock = function () {var _cx;return (
        _react2.default.createElement(_reactScroll.Element, {
            name: _constants.TAB_PROJECT_ID.typesProperties,
            className: (0, _classnames2.default)(styles.projectPropertiesBlock, (_cx = {}, _cx[styles.isMobile] = _this.props.isMobile, _cx)) },

          _react2.default.createElement(_containers.ProjectPropertiesContainer, {
            currency: _this.props.projectData.currency,
            title: _this.props.translate('ProjectDetails', 'projectProperties'),
            projectId: (0, _get3.default)(_this.props, 'projectData.id') })));}, _temp), _possibleConstructorReturn(_this, _ret);}ProjectDetails.prototype.componentWillMount = function componentWillMount() {var id = this.props.projectData.id;var isForeign = (0, _checkIsForeignAddress2.default)(this.props.projectData.address);var _getLocalizedData5 = (0, _getLocalizedData11.default)(this.props.projectData.description, this.props.locale, isForeign),description = _getLocalizedData5.result;var _getLocalizedData6 = (0, _getLocalizedData11.default)(this.props.projectData.summary, this.props.locale, isForeign),summary = _getLocalizedData6.result;this.props.receiveSimilarProjectProperties({ params: { is_mobile: false, id: id } });this.props.detectSummaryLanguage({ q: summary, locale: this.props.locale });this.props.detectDescriptionLanguage({ q: description, locale: this.props.locale });};ProjectDetails.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref5) {var isMobile = _ref5.isMobile,isLightboxOpen = _ref5.isLightboxOpen,descriptionData = _ref5.descriptionData,projectData = _ref5.projectData,summaryData = _ref5.summaryData;var isForeign = (0, _checkIsForeignAddress2.default)(projectData.address);if (isMobile && isLightboxOpen !== this.props.isLightboxOpen) {this.container.style.position = isLightboxOpen ? 'fixed' : 'relative';}if (descriptionData.showOriginalDescription && !descriptionData.descriptionLoading && !descriptionData.descriptionLoaded) {this.props.translateDescription({ q: this.props.projectData.description[isForeign ? 'en' : 'he'] });}if (summaryData.showOriginalSummary && !summaryData.summaryLoading && !summaryData.summaryLoaded) {this.props.translateSummary({ q: this.props.projectData.summary[isForeign ? 'en' : 'he'] });}};ProjectDetails.prototype.renderGallery = function renderGallery() {var _props = this.props,isMobile = _props.isMobile,openLightbox = _props.openLightbox,images = _props.projectData.images,translate = _props.translate;var imagesArray = this.formatImages(images.length ? images : [_images_placeholder2.default]);if (isMobile) {return _react2.default.createElement(_ProjectInlineGallery2.default, { images: imagesArray, openLightbox: openLightbox, isRtl: this.props.isRtl, noLightbox: !images.length, isMobile: this.props.isMobile, isLightboxOpen: this.props.isLightboxOpen });}return _react2.default.createElement(_PropertyGallery2.default, { images: images.slice(0, 5), imagesLength: images.length, translate: translate, openLightbox: openLightbox });};ProjectDetails.prototype.renderDate = function renderDate() {var _this2 = this,_cx2;var _props$projectData = this.props.projectData,createdAt = _props$projectData.created_at,updatedAt = _props$projectData.updated_at;var publishDate = this.formatDate(createdAt, this.props.translate);var updateDate = createdAt !== updatedAt && this.formatDate(updatedAt, this.props.translate);var rowRender = function rowRender(name, date, brackets) {return _react2.default.createElement('span', null, brackets ? '(' : null, _react2.default.createElement('span', { className: styles.label }, _this2.props.translate('propertyDetails', 'details', name)), ':\xA0', date, brackets ? ')' : null);};return _react2.default.createElement('p', { className: (0, _classnames2.default)(styles.date, (_cx2 = {}, _cx2[styles.mobile] = this.props.isMobile, _cx2)) }, rowRender('publishDate', publishDate), '\xA0\xA0', updateDate && rowRender('updateDate', updateDate, true));};ProjectDetails.prototype.




  renderOverlay = function renderOverlay() {
    return (
      _react2.default.createElement('div', { className: styles.overlay },
        _react2.default.createElement('div', { className: styles.inactiveMessage },
          _react2.default.createElement('div', null,
            this.props.translate(
            'propertyDetails',
            'details',
            this.props.projectData.is_deleted ? 'deletedProperty' : 'inactiveProperty')),


          _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(this.props.locale, '/homes/buy') },
            this.props.translate('propertyDetails', 'details', 'backToSearch')))));




  };ProjectDetails.prototype.

  render = function render() {var _this3 = this;var _props2 =
    this.props,isMobile = _props2.isMobile,locale = _props2.locale,projectData = _props2.projectData,isRtl = _props2.isRtl;

    if (!locale || !projectData || !projectData.address) {
      return null;
    }

    var commodities = (0, _get3.default)(this.props, 'projectData.commodities');
    var advantages = (0, _get3.default)(this.props, 'projectData.advantages');
    var isUnlimitedLeads = (0, _get3.default)(this.props, 'projectData.isUnlimitedLeads');
    var projectProperties = (0, _get3.default)(this.props, 'projectProperties');
    var agencyByOwner = (0, _get3.default)(this.props, 'projectData.agency_by_owner');
    var teamData = (0, _get3.default)(this.props, 'projectData.team', {});
    var architect = (0, _get3.default)(teamData, 'architect.title');
    var contractor = (0, _get3.default)(teamData, 'contractor.title');
    var owner = (0, _get3.default)(teamData, 'owner.title');
    var isForeign = (0, _checkIsForeignAddress2.default)(projectData.address);
    var sharingUrl = (0, _makeSharingUrl2.default)('/project_details/' + projectData.id, locale);
    var translate = this.props.translate('propertyDetails');var _getLocalizedData7 =

    (0, _getLocalizedData11.default)(projectData.name, locale),name = _getLocalizedData7.result;var _getLocalizedData8 =
    (0, _getLocalizedData11.default)(projectData.summary, locale),summary = _getLocalizedData8.result;var _getLocalizedData9 =






    (0, _getLocalizedData11.default)(projectData.address, locale, true),_getLocalizedData9$re = _getLocalizedData9.result,street_name = _getLocalizedData9$re.street_name,house_number = _getLocalizedData9$re.house_number,city_name = _getLocalizedData9$re.city_name,neighborhood = _getLocalizedData9$re.neighborhood,country_name = _getLocalizedData9$re.country_name;

    var helmet = this.createHelmet(
    projectData.id,
    projectData.images,
    name,
    sharingUrl,
    summary);

    var localisedPropertyTypes = projectData.property_types.map(function (type) {return _this3.props.translate('propertyTypes', type);});

    var propertyTypesString = localisedPropertyTypes.join(', ');
    var hasPhotos = !!(0, _get3.default)(projectData, 'images.length');
    var contacts = {
      phoneNumber: projectData.phone_number };


    return (
      _react2.default.createElement('div', {
          vocab: 'http://schema.org/',
          'typeof': 'Project',
          className: (0, _classnames2.default)(styles.contentWrapper, this.props.className),
          ref: function ref(container) {_this3.container = container;} },

        helmet,
        this.renderHeader(),
        _react2.default.createElement(_reactScroll.Element, { name: _constants.TAB_PROJECT_ID.main, className: styles.galleryStyle },
          this.renderGallery()),

        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement(_BasicInformation2.default, {
            isUnlimitedLeads: isUnlimitedLeads,
            isForeign: isForeign,
            buildings: projectData.buildings,
            floors: projectData.floors,
            apartments: projectData.apartments,
            locale: this.props.locale,
            name: projectData.name,
            logo: projectData.logo,
            translate: this.props.translate,
            minPrice: projectData.min_property_price,
            id: projectData.id,
            exactPrice: projectData.exact_property_price,
            currency: projectData.currency,
            phoneNumber: projectData.phone_number,
            neighborhood: neighborhood,
            city_name: city_name,
            street_name: street_name,
            isMobile: isMobile,
            house_number: house_number,
            country_name: country_name,
            scrollToForm: this.scrollToForm }),

          city_name && !isMobile &&
          _react2.default.createElement('div', { className: styles.addressWrapper },
            _react2.default.createElement('div', { className: styles.addressLine },
              _react2.default.createElement('p', { className: styles.streetName },
                street_name,
                (!neighborhood || neighborhood === city_name) && ',', '\xA0',

                house_number, ', \xA0'),


              neighborhood &&
              neighborhood !== city_name &&
              _react2.default.createElement('div', null,
                neighborhood, ', \xA0'),



              _react2.default.createElement('div', null, city_name, isForeign && ', ' + country_name))),



          isMobile && this.renderTabs(),
          _react2.default.createElement('div', { className: styles.details },
            this.renderMessageFromCompany(),
            !!advantages && !!advantages.length ? this.renderAdvantagesCompany() : '',
            this.renderSummary(),
            this.renderDescription(),
            !!agencyByOwner && this.renderAboutCompany(),
            (architect || contractor || owner) && this.renderTeamBlock(),
            commodities && commodities.length ? this.renderProjectCommoditiesBlock() : '',
            this.renderPropertiesBlock(),
            this.renderContactsForm()),


          _react2.default.createElement('div', { className: styles.map },
            _react2.default.createElement(_components.PropertyMap, {
              translate: translate('mapContainer'),
              location: projectData.address.location || { lat: 0, lon: 0 },
              locale: locale,
              isMobile: isMobile,
              isModal: this.props.isModal })),


          this.props.projectData && this.renderProjectsBlock(),
          this.props.properties && this.renderSimilarProjects()),


        hasPhotos && this.renderLightbox(),
        _react2.default.createElement('div', { className: styles.metaInfo },
          this.renderDate(),
          this.generateSEOTitle(this.props.projectData)),

        (projectData.is_deactivated || projectData.is_deleted) && this.renderOverlay(),
        _react2.default.createElement(_reactModal2.default, {
            isOpen: this.state.printPageShown,
            contentLabel: 'PropertyDetailsPrintPage',
            portalClassName: 'print-page',
            style: _constants.cleanModalStyle },

          _react2.default.createElement(_components.ProjectDetailsPrintPage, {
            isRtl: isRtl,
            data: projectData,
            locale: locale,
            translate: this.props.translate,
            hidePrintPage: this.hidePrintPage,
            enPropertyType: this.props.enPropertyType,
            contacts: contacts,
            summary: summary,
            propertyTypes: propertyTypesString }))));




  };return ProjectDetails;}(_react.Component);


ProjectDetails.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  isModal: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  projectData: _propTypes2.default.object,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  isLightboxOpen: _propTypes2.default.bool,
  currentImage: _propTypes2.default.number,
  className: _propTypes2.default.string,
  openModalContacts: _propTypes2.default.func,
  hideModalContacts: _propTypes2.default.func,
  isModalContactsOpen: _propTypes2.default.bool,
  screenWidth: _propTypes2.default.number,
  isNative: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  sendProjectContactUsForm: _propTypes2.default.func,
  formSubmitting: _propTypes2.default.bool,
  formSubmitted: _propTypes2.default.bool,
  formError: _propTypes2.default.object,
  openMessageModal: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  isPublish: _propTypes2.default.bool,
  enPropertyType: _propTypes2.default.string,
  propertyNote: _propTypes2.default.string,
  propertyType: _propTypes2.default.string,
  descriptionData: _propTypes2.default.object,
  toggleDescriptionTranslation: _propTypes2.default.func,
  detectDescriptionLanguage: _propTypes2.default.func,
  translateDescription: _propTypes2.default.func,
  resetDescriptionTranslate: _propTypes2.default.func,
  preloadData: _propTypes2.default.object,
  routeData: _propTypes2.default.object,
  properties: _propTypes2.default.array,
  handlePopupClose: _propTypes2.default.func,
  projectProperties: _propTypes2.default.array,
  receiveSimilarProjectProperties: _propTypes2.default.func,
  searchProperty: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  isFavorite: _propTypes2.default.bool,
  userId: _propTypes2.default.string,
  translateSummary: _propTypes2.default.func,
  detectSummaryLanguage: _propTypes2.default.func,
  toggleSummaryTranslation: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  handleEdit: _propTypes2.default.func,
  summaryData: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(state) {return {
    isNative: state.native.isNative };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
ProjectDetails);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/ProjectDetails/ProjectDetails.js
// module id = 2815
// module chunks = 0